import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

const ManageAccountsScreen = () => {
  const [activeTab, setActiveTab] = useState('add-account');
  const [userEmail, setUserEmail] = useState('');
  const [userName, setUserName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleAddAccount = async (e) => {
    if (e) e.preventDefault();
    setIsLoading(true);

    try {
      // Handle add account logic
      if (!userEmail.trim() || !userName.trim()) {
        toast.error('Please fill in all required fields');
        return;
      }
      
      // Make API call to add account
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/add-account`, {
        admin_password: process.env.REACT_APP_ADMIN_PASSWORD || 'admin123',
        email: userEmail.trim(),
        name: userName.trim()
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.data.success) {
        toast.success(response.data.message || 'Account added successfully!');
        setUserEmail('');
        setUserName('');
      } else {
        toast.error(response.data.message || 'Failed to add account');
      }
    } catch (error) {
      console.error('Error adding account:', error);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('An error occurred while adding the account');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseAccount = async (e) => {
    if (e) e.preventDefault();
    if (!userEmail.trim()) {
      toast.error('Please enter user email to close account');
      return;
    }

    if (window.confirm('Are you sure you want to close this account? This action cannot be undone.')) {
      setIsLoading(true);
      try {
        // Make API call to delete account
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/delete-account`, {
          admin_password: process.env.REACT_APP_ADMIN_PASSWORD || 'admin123',
          email: userEmail.trim()
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (response.data.success) {
          toast.success(response.data.message || 'Account closed successfully!');
          setUserEmail('');
          setUserName('');
        } else {
          toast.error(response.data.message || 'Failed to close account');
        }
      } catch (error) {
        console.error('Error closing account:', error);
        if (error.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error('An error occurred while closing the account');
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('is_admin');
    navigate('/admin');
  };

  return (
    <div className="container">
      <div className="admin-header-fullwidth">
        <div className="admin-header-content">
          <div className="admin-header-left">
            <img src="/logo.svg" alt="Project 31 Logo" className="admin-logo" />
         
          </div>
          
          <div className="admin-nav">
            <a href="/admin/dashboard">Dashboard</a>
            <a href="/admin/transactions">Transactions</a>
            <a href="/admin/manage-accounts">Accounts</a>
            <a href="/admin/bitcoins">Bitcoins</a>
          </div>
        </div>
      </div>

      <div className="dashboard-content admin-dashboard-content">
        <div className="manage-accounts-section">
          <h2>Manage Accounts</h2>
          
          <div className="account-tabs">
            <button
              className={`tab-button ${activeTab === 'add-account' ? 'active' : ''}`}
              onClick={() => {
                setActiveTab('add-account');
                setUserEmail('');
                setUserName('');
              }}
            >
              Add Account
            </button>
            <button
              className={`tab-button ${activeTab === 'close-account' ? 'active' : ''}`}
              onClick={() => {
                setActiveTab('close-account');
                setUserEmail('');
                setUserName('');
              }}
            >
              Close Account
            </button>
          </div>

          <div className="single-transaction-section">
            <h3>{activeTab === 'add-account' ? 'Add New Account' : 'Close Account'}</h3>

            <form
              className="account-form"
              onSubmit={activeTab === 'add-account' ? handleAddAccount : handleCloseAccount}
            >
              <div className="form-group">
                <label htmlFor="userEmail">User Email</label>
                <input
                  type="email"
                  id="userEmail"
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                  placeholder="Enter user's email"
                  required
                  disabled={isLoading}
                />
              </div>

              {activeTab === 'add-account' && (
                <div className="form-group">
                  <label htmlFor="userName">User Name</label>
                  <input
                    type="text"
                    id="userName"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    placeholder="Enter user's name"
                    required
                    disabled={isLoading}
                  />
                </div>
              )}

              <div className="form-actions">
                {activeTab === 'add-account' ? (
                  <button
                    type="submit"
                    className="add-button"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Processing...' : 'Add Account'}
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="close-account-button"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Processing...' : 'Close Account'}
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="admin-footer">
        <button onClick={handleLogout} className="admin-logout-button">
          Logout
        </button>
      </div>
    </div>
  );
};

export default ManageAccountsScreen;
